export default {"src":"/_next/static/media/level_6.f4c1a286.svg","height":128,"width":130,"blurWidth":0,"blurHeight":0};